import React from 'react';
const comparisonRows = [{
  situation: 'Tu imagen profesional',
  without: 'Flyer hecho en el celular',
  with: 'Identidad visual premium'
}, {
  situation: 'Protección legal',
  without: 'Contrato verbal o ninguno',
  with: 'Kit completo de documentos'
}, {
  situation: 'Atracción de alumnos',
  without: 'Solo boca a boca',
  with: 'Sistema activo multicanal'
}, {
  situation: 'Tu precio',
  without: 'El de mercado o menos',
  with: '30–50% sobre el mercado'
}];
const blocks = [{
  icon: '💰',
  title: 'Ingeniería de Precios',
  desc: 'Sistema de 3 niveles + cómo comunicar aumentos'
}, {
  icon: '📱',
  title: 'Ventas y Conversión',
  desc: 'Scripts de WhatsApp + cierre en primera clase'
}, {
  icon: '📣',
  title: 'Marketing Digital',
  desc: 'Instagram + 30 temas de contenido + Google My Business'
}, {
  icon: '⚙️',
  title: 'Automatización',
  desc: 'Sistema de suscripción + retención de alumnos'
}, {
  icon: '📅',
  title: 'Plan de 12 Meses',
  desc: 'Hoja de ruta con acciones y metas mensuales'
}, {
  icon: '⚖️',
  title: 'Documentos Legales',
  desc: 'Fichas médicas + deslindes + contratos'
}];
export function EliteSection() {
  return <section className="w-full bg-[#1a0a2e] py-16 px-4" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <div className="text-center mb-10" data-id="element-76">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-77">
            🧘 ¿Qué agrega el{' '}
            <span className="text-[#B87AFF]" data-id="element-78">ESTUDIO PRO ELITE™</span>?
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-79">
            El sistema completo para profesionalizar tu negocio de yoga.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-black border border-[#B87AFF]/30 rounded-2xl overflow-hidden mb-12" data-id="element-80">
          {/* Header */}
          <div className="grid grid-cols-1 sm:grid-cols-3 bg-[#0d0a1a] border-b border-[#B87AFF]/30" data-id="element-81">
            <div className="p-4 font-bold text-white hidden sm:block" data-id="element-82">
              Situación
            </div>
            <div className="p-4 font-bold text-gray-400 text-center border-l border-[#B87AFF]/30" data-id="element-83">
              Sin Estudio Pro Elite
            </div>
            <div className="p-4 font-bold text-[#B87AFF] text-center border-l border-[#B87AFF]/30" data-id="element-84">
              Con Estudio Pro Elite
            </div>
          </div>

          {/* Rows */}
          {comparisonRows.map((row, i) => <div key={row.situation} className={`grid grid-cols-1 sm:grid-cols-3${i < comparisonRows.length - 1 ? ' border-b border-gray-800' : ''}`} data-id="element-85">
              <div className="p-4 text-white text-sm sm:text-base" data-id="element-86">
                <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-87">
                  Situación:
                </span>
                {row.situation}
              </div>
              <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-88">
                <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-89">
                  Sin Estudio Pro Elite:
                </span>
                {row.without}
              </div>
              <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#B87AFF]/5" data-id="element-90">
                <span className="sm:hidden font-bold text-[#B87AFF] block mb-1" data-id="element-91">
                  Con Estudio Pro Elite:
                </span>
                {row.with}
              </div>
            </div>)}
        </div>

        {/* Features List */}
        <h3 className="text-2xl font-black text-white text-center mb-8" data-id="element-92">
          ✅ ESTUDIO PRO ELITE™ INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-93">
          {blocks.map(block => <div key={block.title} className="bg-black border border-[#B87AFF]/20 rounded-xl p-5" data-id="element-94">
              <h4 className="text-[#B87AFF] font-bold text-lg mb-2" data-id="element-95">
                {block.icon} {block.title}
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-96">{block.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}